import React from 'react';
import PropTypes from 'prop-types';

import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@material-ui/core";

import DialogButton from './Dialog/DialogButton';

const propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

const defaultProps = {

};

function ConfirmationDialog (props) {
    const {open, onClose, onConfirm, title, content, actions,titleString , contentString, cancelLabel, confirmationLabel } = props;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
        >
            <DialogTitle disableTypography>
                {
                    title ? title :
                    (<Typography>
                        {titleString ? titleString : 'Are you sure?'}
                    </Typography>)
                }
            </DialogTitle>
            <DialogContent dividers>
                {
                    content ? content :
                    (<Typography>
                        {contentString ? contentString : 'Are you sure you want to perform this action?'}
                    </Typography>)
                }
            </DialogContent>
            <DialogActions>
                {
                    actions ? actions :
                    (
                        <>
                            <DialogButton
                                onClick={onConfirm}
                                variant="contained"
                            >
                                {confirmationLabel ? confirmationLabel : 'Yes'}
                            </DialogButton>
                            <DialogButton
                                onClick={onClose}
                                variant="outlined"
                            >
                                {cancelLabel ? cancelLabel : 'Cancel'}
                            </DialogButton>
                        </>
                    )
                }
                
            </DialogActions>
        </Dialog>
    )
}

ConfirmationDialog.prototype = propTypes;
ConfirmationDialog.defaultProps = defaultProps;

export default ConfirmationDialog;